import { Injectable } from '@angular/core';
import { FolliaWidgetWebService } from './follia-widget-web.service';

@Injectable({
  providedIn: 'root',
})
export class FolliaWidgetService {
  constructor(private readonly folliaWidgetWebService: FolliaWidgetWebService) {}

  public getJWTFollia(idStoricoChat: string | null) {
    return this.folliaWidgetWebService.getJWTFollia(idStoricoChat);
  }

  public getStatoFile(tenantId: string, companyId: string, datasourceIds: string, token: string) {
    return this.folliaWidgetWebService.getStatoFile(tenantId, companyId, datasourceIds, token);
  }

  public getIdDatasourceDefault(tipo: string) {
    return this.folliaWidgetWebService.getIdDatasourceDefault(tipo);
  }
}
